function CompanySearchInterceptor(GeneralOptions) {
    'ngInject';

    return {
        request(config) {
            if (GeneralOptions.suppressChildCompanies && config.url.match(/\/company(\/|$)/)) {
                const operator = config.url.contains('?') ? '&' : '?';
                config.url = `${config.url}${operator}embed=no_child_companies`;
            }
            return config;
        }
    };
}

angular
    .module('BB')
    .service('companySearchInterceptor', CompanySearchInterceptor);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/company_search_interceptor.service.js